import axios from 'axios';
import { apiUrl } from '../constant';

const startImpersonation = (data) => {
    return axios.post(`${apiUrl}/api/Impersonation/Start`, data);
};

const endImpersonation = () => {
    return axios.post(`${apiUrl}/api/Impersonation/End`, {});
};

export const impersonationService = {
    startImpersonation,
    endImpersonation,
};
